package com.dotdrives.web

import com.dotdrives.web.pages.SignInStyles
import com.dotdrives.web.ui.DotTheme
import react.FC
import react.Props
import react.create
import react.dom.client.createRoot
import web.dom.ElementId
import web.dom.document

private val WebApp = FC<Props> {
    DotTheme {
        SignInStyles()
        AppRoot()
    }
}

fun main() {
    val root = requireNotNull(document.getElementById(ElementId("root"))) {
        "Missing #root element"
    }
    createRoot(root).render(WebApp.create())
}
